<!-- 持卡人信息 每次绑定卡，用户确认卡信息；-->
<!-- 名字：允许编辑；原来为仅白名单用户可以自行编辑 -->
<!-- 国家：为空或者对应不上的时候允许编辑 -->
<!-- 生日：为空时允许编辑 -->

<template>
  <el-dialog
    :model-value="dialogVisible"
    :title="$t('cards.card-manage.verification_required')"
    width="500"
    destroy-on-close
    @close="emits('update:visible', false)"
  >
    <div :class="$style.body">
      <div :class="$style.tip">{{ $t('cards.card-manage.verification_tip', [bindFeeFormat]) }}</div>
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-form-item :label="$t('cards.card-manage.first_name') + '-EN'" prop="firstName">
          <el-input
            v-model="form.firstName"
            :maxlength="30"
            :placeholder="$t('cards.card-manage.placeholder_input_name_prefix_tip')+' '+$t('cards.card-manage.max_number_chars', [30])"
          />
        </el-form-item>
        <el-form-item :label="$t('cards.card-manage.last_name') + '-EN'" prop="lastName">
          <el-input
            v-model="form.lastName"
            :maxlength="30"
            :placeholder="$t('cards.card-manage.placeholder_input_name_prefix_tip')+' '+$t('cards.card-manage.max_number_chars', [30])"
          />
        </el-form-item>
        <el-form-item :label="$t('cards.card-manage.date_of_birth')" prop="birthday">
          <el-date-picker
            :prefix-icon="CalendarIconSvg"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :placeholder="$t('cards.card-manage.select_date_of_birth')"
            v-model="form.birthday"
            type="date"
            :disabled="!editableDob"
            :clearable="false"
            :disabled-date="disabledDate"
            style="width: 100%"
            :class="$style.cardsDatePicker"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('cards.card-manage.country')" prop="country">
          <el-select
            v-model="form.country"
            :disabled="!editableCountry"
            :options="countryList"
            filterable
            style="width: 100%"
            :suffix-icon="SelectOpenIcon"
            :class="$style.cardsSelect"
          >
            <el-option
              v-for="item in countryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('cards.card-manage.city')" prop="city">
          <el-input
            v-model="form.city"
            :maxlength="30"
            :placeholder="$t('cards.card-manage.length_from_to', [2, 30])"
          />
        </el-form-item>
        <el-form-item :label="$t('cards.card-manage.address')" prop="street">
          <el-input
            v-model="form.street"
            :maxlength="35"
            :placeholder="$t('cards.card-manage.length_from_to', [3, 35])"
          />
        </el-form-item>
        <el-form-item :label="$t('cards.card-manage.state_code')" prop="stateCode">
          <el-input
            v-model="form.stateCode"
            :maxlength="3"
            :placeholder="$t('cards.card-manage.length_from_to', [2, 3])"
          />
        </el-form-item>
        <el-form-item :label="$t('cards.card-manage.zip_code')" prop="zipCode">
          <el-input
            v-model="form.zipCode"
            :maxlength="10"
            :placeholder="$t('cards.card-manage.length_from_to', [2, 10])"
          />
        </el-form-item>

        <el-button type="primary" @click="submitForm(formRef)" style="height: 44px; width: 100%">
          {{ $t(type === UpdateType ? 'common.confirm' : 'cards.card-manage.go_add_card') }}
        </el-button>
      </el-form>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ElSelect, type  FormInstance, FormRules } from 'element-plus';
import { track, SENSOR_EVENT_NAME } from '~/frontend-shared/helper/sensor';
import { bindCard_post, replenishUserInfo_post } from '~/api/cards/trade';
import { useCardsStore } from '~/store/cards';
import { useCountryList } from '~/common/js/helper';
import { COUNTRY_BIZ_TYPE_ENUM } from '~/common/js/const';
import { usePatchStore } from '@/common/js/patch';
import { fiatJSON } from '@/common/js/const';
import SelectOpenIcon from '@/components/p2p/Select/OpenIndicator.vue';
import CalendarIconSvg from '@/assets/icon/calendar.svg?component';

import moment from 'moment';
const store = usePatchStore();

const UpdateType = 'update';

interface RuleForm {
  firstName: string;
  lastName: string;
  country: string;
  city: string;
  street: string;
  stateCode: string;
  zipCode: string;
  birthday: string; // 添加生日字段
}

const props = defineProps(['type', 'visible', 'channelType', 'currency', 'addCardFormValue', 'cardId']);
const emits = defineEmits(['update:visible']);

const cardsStore = useCardsStore();
const { t } = useI18n();

const countryList = ref([] as any[]);

const dialogVisible = ref(props.visible);

const disabledDate = (time: any) => {
  const current = moment(time).unix();
  return current > moment().unix();
};

watch(
  () => props.visible,
  (newVisible) => {
    dialogVisible.value = newVisible;
    // 打开
    if(newVisible && props.type !== UpdateType) {
    track(SENSOR_EVENT_NAME.CARDS.click_add_bankcard, {
      web_fiat_card_buy_coin: props.addCardFormValue?.crypto,
      web_fiat_card_buy_fiat: props.currency,
      web_fiat_card_buy_coinamount: props.addCardFormValue?.size,
      web_fiat_card_buy_fiatamount: props.addCardFormValue?.amount,
      web_fiat_fiatgateway_buy_kyccountry: cardsStore.userInfo.kycCountry,
    });
  }
  }
);

const bindFeeFormat = computed(() => {
  const v = fiatJSON[props.currency || 'USD'] || props.currency || '$';
  //new Intl.NumberFormat('en-US', { style: 'currency', currency: props.currency, }).format(1);
  return `${v} 1`;
});

const editableCountry = computed(() => {
  const myCountry = cardsStore.userInfo?.country ?? cardsStore.userInfo?.kycCountry;
  return (
    !myCountry ||
    !countryList.value?.find((i) => i.value === myCountry)
  );
});

const editableDob = computed(() => {
  const dobregex = /^\d{4}-\d{2}-\d{2}$/;
  return !cardsStore.userInfo?.birthday || dobregex.test(cardsStore.userInfo?.birthday) !== true;
});

watch([() => cardsStore.userInfo, () => props.visible], ([newUserInfo, newVisible]) => {
  if (!newVisible || !newUserInfo) {
    return;
  }
  // 非白名单用户 禁止编辑
  form.firstName = newUserInfo?.firstName;
  form.lastName = newUserInfo?.lastName;
  form.country = newUserInfo?.country ?? newUserInfo?.kycCountry;
  form.city = newUserInfo?.city;
  form.street = newUserInfo?.street;
  form.stateCode = newUserInfo?.stateCode;
  form.zipCode = newUserInfo?.zipCode;
  form.birthday = newUserInfo?.birthday;
});
const formRef = ref<FormInstance>();

const form = reactive<RuleForm>({
  firstName: '',
  lastName: '',
  country: '',
  city: '',
  street: '',
  stateCode: '',
  zipCode: '',
  birthday: '',
});

const rules = reactive<FormRules<RuleForm>>({
  firstName: [
    {
      required: true,
      message: t('cards.card-manage.english_name_validation_blank', [t('cards.card-manage.first_name')]),
      trigger: 'blur',
    },
    {
      pattern: /^\s*[a-zA-Z]+(?: [a-zA-Z]+)*\s*$/,
      message: t('cards.card-manage.english_name_validation'),
      trigger: 'blur',
    },
  ],
  lastName: [
    {
      required: true,
      message: t('cards.card-manage.english_name_validation_blank', [t('cards.card-manage.last_name')]),
      trigger: 'blur',
    },
    {
      pattern: /^\s*[a-zA-Z]+(?: [a-zA-Z]+)*\s*$/,
      message: t('cards.card-manage.english_name_validation'),
      trigger: 'blur',
    },
  ],
  birthday: [
    {
      required: true,
      message: t('cards.card-manage.please_input_date', [t('cards.card-manage.birthday')]),
      trigger: 'blur',
    },
  ],
  country: [
    {
      required: true,
      message: t('cards.card-manage.please_input_name', [t('cards.card-manage.country')]),
      trigger: 'blur',
    },
  ],
  city: [{ min: 2, max: 30, required: true, message: t('cards.card-manage.length_from_to', [2, 30]), trigger: 'blur' }],
  street: [
    { required: true, min: 3, max: 35, message: t('cards.card-manage.length_from_to', [3, 35]), trigger: 'blur' },
  ],
  stateCode: [
    { required: false, min: 2, max: 3, message: t('cards.card-manage.length_from_to', [2, 3]), trigger: 'blur' },
  ],
  zipCode: [
    { required: true, min: 2, max: 10, message: t('cards.card-manage.length_from_to', [2, 10]), trigger: 'blur' },
  ],
});

const COUNTRIES_NEED_STATE = ['US', 'CA', 'AU'];

watch(
  () => form.country,
  (newCountry) => {
    if (!COUNTRIES_NEED_STATE.includes(newCountry)) {
      // form.stateCode = '';
      // @ts-ignore
      rules.stateCode[0].required = false;
    } else {
      // @ts-ignore
      rules.stateCode[0].required = true;
    }
  }
);
// function handleClose() {
//   form.street = '';
//   form.city = '';
//   form.country = '';
//   form.firstName = '';
//   form.lastName = '';
//   form.stateCode = '';
//   form.zipCode = '';
//   // emits('update:visible', false);
// }

const route = useRoute();

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (!valid) return;

    const params = {
      ...form,
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
    };

    if (props.type === UpdateType) {
      replenishUserInfo_post({
        data: params,
      })
        .then((res) => {
          console.log('replenishUserInfo_post res: ', res);
          emits('update:visible', false);
        })
        .catch((err) => {
          console.log('replenishUserInfo_post err: ', err);
        });
      return;
    }

    const url = window.location.origin + `/cards/trade-result/${route.params.lang}?type=cardBind`;

    bindCard_post({
      data: {
        channelType: props.channelType,
        currency: props.currency,
        ...params,
        successUrl: `${url}&status=success`,
        failUrl: `${url}&status=fail`,
      },
    }).then((res) => {
      if (res?.success && res.data) {
        emits('update:visible', false);
        // dose orderNo useful？
        window.location.href = res.data.url;
      }
    });
  });
};

onMounted(async () => {
  await useCountryList(store, COUNTRY_BIZ_TYPE_ENUM.ALL_AREA_CODE).then((res) => {
    countryList.value =
      res?.map((item: any) => ({
        ...item,
        value: item.countryCodeAlpha_2,
        label: item.countryNameLocal || item.countryName,
      })) || [];
  });
});
</script>

<style lang="less" module>
.body {
  :global {
    .el-form-item {
      margin-bottom: 12px;
    }
    .el-form-item.is-error {
      margin-bottom: 26px;
    }
  }
}

.tip {
  color: var(--text-color-primary);
  margin-bottom: 18px;
}

.payWrapper {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.inputLabel {
  font-size: 14px;
  color: #666;
  margin-right: 10px;
}

.cardsDatePicker{
  :global(.el-input__wrapper){
    flex-direction: row-reverse;
  }
  :global(.el-input__inner){
    padding-left: 0 !important;
  }
  :global{
    i.el-input__icon{
      margin-left: 9px !important;
      margin-right: 0 !important;
    }
    .el-input.is-disabled .el-input__wrapper{
      background-color: transparent !important;
      
    }
  }
}
</style>
